<!--Dropdown section starts-->
<section id="dropdown">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Dropdown</div>
    </div>
  </div>
  <div class="row text-left">
    <!--Toggle dropdown starts-->
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Toggle dropdown</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div ngbDropdown>
              <button class="btn btn-outline-primary mr-1" id="dropdownBasic1" ngbDropdownToggle>Toggle
                dropdown</button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button class="dropdown-item">Action - 1</button>
                <button class="dropdown-item">Another Action</button>
                <button class="dropdown-item">Something else is here</button>
              </div>
              <div ngbDropdown placement="top-right" class="d-inline-block">
                <button class="btn btn-outline-primary" id="dropdownBasic2" ngbDropdownToggle>Toggle dropup</button>
                <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownBasic2">
                  <button class="dropdown-item">Action - 1</button>
                  <button class="dropdown-item">Another Action</button>
                  <button class="dropdown-item">Something else is here</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Toggle dropdown ends-->
  </div>
  <div class="row text-left">
    <!--Manual triggers starts-->
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Manual triggers</h4>
          <p>You can easily control dropdowns programmatically using the exported dropdown instance.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div ngbDropdown #myDrop1="ngbDropdown">
              <button class="btn btn-outline-primary mr-1" id="dropdownMenu2" ngbDropdownToggle>Toggle dropdown</button>
              <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <button class="dropdown-item">Action - 1</button>
                <button class="dropdown-item">Another Action</button>
                <button class="dropdown-item">Something else is here</button>
              </div>
              <button class="btn btn-outline-success mr-1" (click)="$event.stopPropagation(); myDrop1.open();">Open
                from
                outside</button>
              <button class="btn btn-outline-danger" (click)="$event.stopPropagation(); myDrop1.close();">Close from
                outside</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Manual triggers ends-->
  </div>
  <div class="row text-left">
    <!--Button groups and split buttons starts-->
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Button groups and split buttons</h4>
          <p>Bootstrap split buttons and dropdowns on button groups are supported with the existing dropdown
            directives.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
              <button type="button" class="btn btn-danger">Action</button>
              <button type="button" class="btn btn-danger dropdown-toggle" ngbDropdownToggle
                aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu" role="menu">
                <a class="dropdown-item">Action</a>
                <a class="dropdown-item">Another action</a>
                <a class="dropdown-item">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item">Separated link</a>
              </div>
            </div>
            <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
              <button type="button" class="btn btn-outline-danger">Action</button>
              <button type="button" class="btn btn-outline-danger dropdown-toggle" ngbDropdownToggle
                aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu" role="menu">
                <a class="dropdown-item">Action</a>
                <a class="dropdown-item">Another action</a>
                <a class="dropdown-item">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item">Separated link</a>
              </div>
            </div>
            <div class="dropdown btn-group mr-1 mb-1" ngbDropdown>
              <button type="button" class="btn btn-info dropdown-toggle" ngbDropdownToggle>
                Dropdown
                <span class="caret"></span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu" role="menu">
                <a class="dropdown-item">Action</a>
                <a class="dropdown-item">Another action</a>
                <a class="dropdown-item">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item">Separated link</a>
              </div>
            </div>
            <div class="dropdown btn-group mr-1 mb-1" ngbDropdown>
              <button type="button" class="btn btn-outline-info dropdown-toggle" ngbDropdownToggle>
                Dropdown
                <span class="caret"></span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu" role="menu">
                <a class="dropdown-item">Action</a>
                <a class="dropdown-item">Another action</a>
                <a class="dropdown-item">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item">Separated link</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Button groups and split buttons ends-->
  </div>
</section>
<!--Dropdown section ends-->
